import { render, staticRenderFns } from "./protection.vue?vue&type=template&id=79196da9&scoped=true&"
import script from "./protection.vue?vue&type=script&lang=js&"
export * from "./protection.vue?vue&type=script&lang=js&"
import style0 from "./protection.vue?vue&type=style&index=0&id=79196da9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79196da9",
  null
  
)

export default component.exports